import { Maybe } from '@expane/data'
import { FC } from 'react'
import { BOOKING_STATUS_COLORS } from 'widgets/BookingStatusTracker'

export const BookingStatusIndicator: FC<{ status: Maybe<number> | undefined }> = ({ status }) => {
  const color = BOOKING_STATUS_COLORS[status ?? 0]

  return <div className={`bg-${color} w-1 h-4 mr-1 rounded-md`} />
}
